import {
    NinchatActionType,
    NinchatCreateMasterKeyAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'

import {NinchatMasterKeyCreatedEvent} from 'api/types/events'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const createMasterKey = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatCreateMasterKeyAction}`,
    async (arg: NinchatActionParams<NinchatCreateMasterKeyAction>, {rejectWithValue}) => {
        const {...params} = arg
        // const {
        //    key_material, ...params
        // } = arg

        params.action = NinchatActionType.NinchatCreateMasterKeyAction

        try {
            return await ninchatClient.send(params) as NinchatMasterKeyCreatedEvent
            // return await ninchatClient.send(params, key_material ? [key_material] : undefined) as unknown as NinchatMasterKeyCreatedEvent
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
